function schemaOrgBlockExists(id: string, type: string|undefined): boolean {
  const scriptBlocks = document.querySelectorAll('script[type="application/ld+json"]')
  for (const scriptBlock of scriptBlocks) {
    if(scriptBlock.id === id) {
      return true;
    }
    if(type && scriptBlock.textContent?.includes(type)) {
      return true;
    }
  }
  return false;
}

export function schemaOrgInjector(id: string, data: string, ifNotExistsType: string|undefined) {
  if (schemaOrgBlockExists(id, ifNotExistsType)) {
    return
  }

  const schemaDataWithUrl = data.replaceAll('https://unknown.invalid', location.href)

  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.id = id;
  script.textContent = schemaDataWithUrl;
  document.body.appendChild(script);
}

export function removeSchemaOrgInjector(id: string) { document.getElementById(id)?.remove() }
